import React from "react";
import { useTranslations } from '../../locales/useTranslations';
import { BiConversation, BiUserPin, BiGlobe, BiBookOpen, BiStar, BiCloud } from "react-icons/bi";

const KarriereWerte = () => {
  const { t } = useTranslations();

  const values = [
    {
      icon: BiConversation,
      title: t('career_values_communication_title'),
      description: t('career_values_communication_description')
    },
    {
      icon: BiUserPin,
      title: t('career_values_equality_title'),
      description: t('career_values_equality_description')
    },
    {
      icon: BiGlobe,
      title: t('career_values_sustainability_title'),
      description: t('career_values_sustainability_description')
    },
    {
      icon: BiBookOpen,
      title: t('career_values_expertise_title'),
      description: t('career_values_expertise_description')
    },
    {
      icon: BiStar,
      title: t('career_values_workLifeBalance_title'),
      description: t('career_values_workLifeBalance_description')
    },
    {
      icon: BiCloud,
      title: t('career_values_digitalization_title'),
      description: t('career_values_digitalization_description')
    }
  ];

  return (
    <div className="features-area pt-100 pb-70 karriere-werte">
      {/* Dekorative Hintergrund-Elemente */}
      <div className="karriere-werte__decoration karriere-werte__decoration--top-right" />
      <div className="karriere-werte__decoration karriere-werte__decoration--bottom-left" />

      <div className="container karriere-werte__content">
        <div className="section-title text-center mb-5">
          <span className="karriere-werte__badge">
            {t('career_values_subtitle')}
          </span>
          <h2 className="karriere-werte__title">
            {t('career_values_title')}
          </h2>
        </div>

        <div className="row karriere-werte__grid">
          {values.map((value, index) => (
            <div key={index} className="col-lg-4 col-sm-6 karriere-werte__col">
              <div className="karriere-werte__card">
                <div className="karriere-werte__icon-wrapper">
                  <value.icon className="karriere-werte__icon" />
                </div>
                <h3 className="karriere-werte__card-title">
                  {value.title}
                </h3>
                <p className="karriere-werte__card-text">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KarriereWerte;
